import { defineNuxtPlugin } from 'nuxt/app';
import { computed, type Ref } from 'vue';
import { useEasyPaisaStore } from '~/stores/easypaisa';

export default defineNuxtPlugin(() => {
	const authStore = useEasyPaisaStore();
	authStore.detectMiniapp();

	return {
		provide: {
			isEasypaisaMiniapp: computed(() => authStore.isEasypaisaMiniapp),
		},
	};
});

declare module 'nuxt/app' {
	interface NuxtApp {
		$isEasypaisaMiniapp: Ref<boolean>;
	}
}
